<template>
  <div>
    {{ banner.headline }}
  </div>
</template>

<script>
export default {
  name: 'BannerSection',
  data: () => ({
    banner: {
      headline: '',
    },
  }),
  mounted() {
    this.getDataFromApi()
      .then(responseData => {
        if (responseData.headline) {
          this.banner.headline = responseData.headline;
          this.$emit('headlineLoaded', responseData.headline);
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  },
  methods: {
    getDataFromApi() {
      console.log('Loading data');

      return new Promise((resolve, reject) => {
        this.axios
          .get('api/v1/campaign/published')
          .then(res => {
            console.log('API response:', res);
            if (res.status === 200) {
              const responseData = res.data;
              console.log('Extracted data:', responseData);
              resolve(responseData);
            } else {
              reject(new Error(`API request failed with status: ${res.status}`));
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);

            reject(error);
          });
      });
    },
  },
};
</script>
